module.exports = __webpack_public_path__ + "static/media/bluesky-vue-logo.130788cf.png";